import { GALACTICA_BACKEND } from 'utils/config';
import { GQLOperations } from 'types/dt-graphql-apollo-v2';
import { parseRefId } from './misc';

export const getProjectGraphQLUrl = (refId?: string | null) => {
  const { dataModel, dataModelVersion, space } = parseRefId(refId);
  return `${GALACTICA_BACKEND}/api/v1/projects/spaces/${space}/datamodels/${dataModel}/versions/${dataModelVersion}/graphql`;
};

const getITGGraphQLUrl = () => `${GALACTICA_BACKEND}/api/v1/projects/graphql`;

export const getITGInterceptor: typeof fetch = (_input, init) => {
  const options: RequestInit = init ?? {};
  let operationName: string | undefined;
  try {
    const rawBody = typeof options.body === 'string' ? options.body : '';
    if (rawBody) {
      const parsed = JSON.parse(rawBody);
      operationName = parsed?.operationName;
    }
  } catch (_) {
    // ignore body parse errors
  }
  let url = getITGGraphQLUrl();
  if (
    operationName &&
    (operationName in GQLOperations.Query ||
      operationName in GQLOperations.Mutation)
  ) {
    url = getITGDTGraphQLUrl(1);
  }
  return fetch(url, options);
};

const getITGDTGraphQLUrl = (version: number) => {
  const dedicatedGalacticaId =
    process.env.REACT_APP_GALACTICA_PROJECT_ID?.trim();
  if (dedicatedGalacticaId) {
    return `https://itg.test.cognite.ai/api/v${version}/projects/${dedicatedGalacticaId}/graphql`;
  }
  return `${GALACTICA_BACKEND}/api/v${version}/graphql`;
};
